<template>
  <div class="all">
    <!-- 底部 -->
    <mall-fotter></mall-fotter>
    <!-- 顶部导航 -->
    <mall-header ref="header"></mall-header>
    <!-- 内容 -->
    <div class="content">
      <div class="content_detail">
        <!-- 标题 -->
        <div class="pageTitle ovh">
          <!-- <div class="pageTitleList f_l ovh" @click="goIndex">
            <p class="pageTitleListTable f_l">乐冰雪首页</p>
            <div class="pageTitleListImg f_l">
              <img src="../../static/index/right.png" />
            </div>
          </div> -->
          <div class="pageTitleList f_l ovh">
            <p class="pageTitleListTable f_l">我的订单</p>
            <div class="pageTitleListImg f_l">
              <img src="../../static/index/right.png" />
            </div>
          </div>
        </div>
        <!-- 内容 -->
        <div class="contentInfo">
          <!-- 顶部tab切换 -->
          <div class="category ovh">
            <div class="categoryTabAll f_l ovh">
              <div v-for="(item, index) in orderTab" :key="index" class="tab txt_a_c f_l" :class="[tabCode == item.id ? 'tabListSelect' : 'tabList']" @click="tabClick(item)">
                {{item.name}}
              </div>
            </div>
            <div class="categorySearch f_r ovh">
              <div class="f_r ovh">
                <div class="input f_l">
                  <input class="searchInput" v-model="searchTxt" placeholder="请输入商品订单或订单号进行搜索" placeholder-color="#979797"></input>
                </div>
                <div class="button f_r" @click="search">搜索订单</div>
              </div>
            </div>
          </div>
          <!-- 订单列表 -->
          <div class="order" v-for="(item, index) in orderList" :key="index">
            <div class="number">订单编号：{{item.trade_id}}</div>
            <div class="orderList ovh" >
              <div class="orderImg f_l ovh">
                <img :src="item.goods_cover" />
              </div>
              <div class="orderInfo f_r ovh">
                <div class="order_title txt_a_l">{{item.address}}{{item.goods_name}}</div>
                <div class="order_tab ovh">
                  <div class="order_tab_list f_l overflow">
                    <div class="order_tab_list_det f_l" v-if="item.goods_label !== null">{{item.goods_label}}</div>
                  </div>
                  <div class="order_tab_num f_r">
                    X 1
                  </div>
                </div>
                <div class="orderMoney txt_a_l">
                  ¥<span>{{item.pay_price}}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <el-pagination
            style="margin: 50px 0 70px 0"
            background
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="5"
            :current-page="pageNum"
            :total="pageNumAll">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 引入共用的css
	import "../components/css/component.css";

  // 顶部导航
  import MallHeader from '@/components/headTop.vue';
  // 底部
  import MallFotter from '@/components/fotter.vue';

  // 调用的接口
  import { getOrderList } from '@/request/api.js';
  import { baseUrl } from '@/request/request.js'

  export default {
    name: 'myOrder',
    data () {
      return {
        tabCode: 0, // 默认选中所有订单
        orderTab: [{
          id: 0,
          name: '所有订单'
        }, {
          id: 1,
          name: '待付款'
        }, {
          id: 2,
          name: '已付款'
        }, {
          id: 3,
          name: '已完成'
        }, {
          id: 4,
          name: '已退款'
        }, {
          id: 5,
          name: '已取消'
        }], // 订单tab数组
        searchTxt: '', // 搜索内容
        orderList: [], // 订单列表
        pageNum: 0, // 页数
        pageNumAll: 1 // 总条数
      }
    },

    // 引用顶部,底部,下单支付
    components:{
      'mall-header': MallHeader, // 顶部导航
      'mall-fotter': MallFotter // 底部导航
    },

    mounted() {
      // 导航选择
      this.navigation(2);
      // 获取订单列表
      this.getOrderList(this.tabCode);
    },

    computed:{
      
    },

    methods:{
      // 获取订单列表
      getOrderList(status) {
        // 订单状态（1;待付款状态2、已付款状态4、已完成8、已取消16、已退款32已失效）
        var order_state = null
        // 判断状态对应
        if(status == 1) {
          // 待付款
          order_state = 1;
        }else if(status == 2) {
          // 已付款
          order_state = 2;
        }else if(status == 3) {
          // 已完成
          order_state = 4;
        }else if(status == 4) {
          // 已退款
          order_state = 16;
        }else if(status == 5) {
          // 已取消
          order_state = 8;
        }
        // 参数
        var parameter = {
          order_state: order_state, // 状态
          page: this.pageNum, // 页数
          token: localStorage.getItem('token') // token
        }
        if(parameter.order_state == null) {
          delete parameter.order_state
        }
        // 调用打卡列表接口
        getOrderList(parameter).then(res => {
          if(res.code == 0) {
            var list = res.data.data;
            for(let i in list) {
              list[i].goods_cover = baseUrl() + list[i].goods_cover;
            }
            // 订单列表赋值
            this.orderList = list;
            console.log(this.orderList)
            // 总条数赋值
            this.pageNumAll = res.data.total;
          }
        })
      },

      // 选中订单状态
      tabClick(e) {
        this.tabCode = e.id;
        // 页数赋值
        this.pageNum = 0;
        // 获取订单列表
        this.getOrderList(this.tabCode);
      },

      // 点击搜索按钮
      search() {
        console.log(this.searchTxt)
      },

      // 点击选中页数
      pageChange(e) {
        // 页数赋值
        this.pageNum = e;
        // 获取订单列表
        this.getOrderList(this.tabCode);
      },

      // 导航选择
      navigation(code) {
        this.$nextTick(() => {
          this.$refs.header.init(code)
        })
      },

      // 点击返回首页
      goIndex() {
        this.$router.push({
          name: 'index',
          params: {}
        })
      },
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  .calendar {
    width: 100%;
    background: #FAFCFF;
    margin: 31px 0 20px 0;
    padding: 29px 14px;
    box-sizing: border-box;
    border-radius: 19px 19px 0px 0px;
    cursor: pointer;
    .calendar-box {
      width: 100%;
      height: 100%;
      position: relative;
      .calendar-body {
        width: 100%;
        margin: 0 auto;
        .calendar-body-text {
          width: 100%;
          height: 30px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          color: #434444;
          font-weight: bold;
          font-size: 25px;
          margin-bottom: 17px;
          .text-title {
            margin: 0 20px;
          }
        }
      }
      table tr th{
        color: #ccc;
      }
      table tr th, table tr td {
        width: 130px;
        height: 66px;
      }
      table td {
        &.activeDay {
          background-color: #FF7702;
          border-radius: 4px;
          font-size: 22px;;
        }
        .currentMonth {
          color: #00BFFF
        }
        .data_money {
          font-size: 18px;
          color: #DF0002;
        }
        .data_mo {
          font-size: 18px;
          color: #fff;
        }
      }
      table td span{
        color: #333;
        cursor: pointer;
      }
      table td span.default{
        color: #e9e9e9;
      }
  }
  }
  .content {
    min-width: 1200px;
    padding: 50px 0 530px 0;
    .content_detail {
      width: 1200px;
      margin: 0 auto;
      // 页面标题
      &> .pageTitle {
        padding: 36px 0 20px 0;
        &> .pageTitleList {
          margin-right: 48px;
          &> .pageTitleListTable {
            color: #434444;
            font-size: 24px;
          }
          &> .pageTitleListImg {
            margin-left: 18px;
            width: 14px;
            height: 20px;
            margin-top: 7px;
          }
        }
        &> .pageTitleList:first-child > .pageTitleListTable {
          color: #0F7DFF;
          cursor: pointer;
        }
      }
      // 内容
      &> .contentInfo {
        min-width: 1200px;
        margin: 0 auto;
        padding-top: 44px;
        // tab栏
        &> .category {
          &> .categoryTabAll {
            width: 759px;
            &> .tab {
              width: 126.5px;
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #434444;
              cursor: pointer;
              height: 48px;
              line-height: 48px;
            }
            &> .tabListSelect {
              color: #0F7DFF;
              border-bottom: 1px solid #0F7DFF;
            }
            &> .tabList {
              color: #434444;
              border-bottom: 1px solid #E3E4E4;
            }
          }
          &> .categorySearch {
            width: 441px;
            height: 48px;
            line-height: 48px;
            border-bottom: 1px solid #E3E4E4;
            padding-top: 4px;
            box-sizing: border-box;
            &> div {
              width: 400px;
              height: 38px;
              border-radius: 4px;
              // border: 1px solid #979797;
              &> .input {
                width: 320px;
                border-left: 1px solid #979797;
                border-top: 1px solid #979797;
                border-bottom: 1px solid #979797;
                border-radius: 4px 0px 0px 4px;
                height: 36px;
                line-height: 38px;
                &> .searchInput {
                  color: #434343;
                  width: 300px;
                  height: 36px;
                  line-height: 38px;
                  font-size: 16px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  letter-spacing: 1px;
                }
              }
              &> .button {
                width: 79px;
                height: 40px;
                line-height: 38px;
                background: #0F7DFF;
                border-radius: 0px 4px 4px 0px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                cursor: pointer;
              }
            }
          }
        }
        // 订单
        &> .order {
          &> .number {
            padding: 37px 39px 0 39px;
            text-align:left;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #999;
            margin-bottom: 5px;
          }
          // 订单列表
          &> .orderList {
            padding: 0 39px 37px 39px;
            &> .orderImg {
              width: 229px;
              height: 133px;
              border-radius: 4px;
              margin-right: 45px;
            }
            &> .orderInfo {
              width: 847px;
              &> .order_title {
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #484949;
              }
              &> .order_tab {
                margin-top: 15px;
                &> .order_tab_list {
                  &> .order_tab_list_det {
                    padding: 0 7px;
                    height: 20px;
                    line-height: 20px;
                    background: #EBF4FF;
                    border-radius: 4px;
                    border: 1px solid #0F7DFF;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #0F7DFF;
                    margin-right: 12px;
                  }
                  &> .order_tab_list_det:last-child {
                    margin-right: 0;
                  }
                }
                &> .order_tab_num {
                  font-size: 20px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #727273;
                }
              }
              &> .orderMoney {
                margin-top: 20px;
                font-size: 14px;
                color: #FF7702;
                font-weight: 600;
                font-family: PingFangSC-Semibold, PingFang SC;
                &> span {
                  font-size: 30px;
                }
              }
            }
          }
        }
      }
    }
  }
  .font {
    font-size: 22px;
  }
  .m_19 {
    margin-top: 19px;
  }
  .el-carousel__item.is-active {
    z-index: 0;
  }
  .col_1 {
    color: #0F7DFF !important;
  }
</style>
<style scoped lang="">

  /deep/ .el-radio__input.is-checked+.el-radio__label {
    color: #fff;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #FE951E;
    background: #FE951E;
  }

  /deep/ .el-radio__label {
    font-size: 16px !important;
    letter-spacing: 1px;
    color: #fff;
  }

  /deep/ .el-calendar-table .el-calendar-day {
    padding: 2px;
  }

  /deep/ .el-calendar-table .el-calendar-day {
    height: 66px;
  }

  /deep/ .inputNum > input:focus{border: 1px solid #DCDFE6 !important;}

  /deep/ .inputNum > input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  /deep/ .inputNum > input[type="number"]{
    -moz-appearance: textfield;
  }
</style>



// WEBPACK FOOTER //
// src/page/myOrder.vue